import Button from '@components/Button';
import ButtonOutlined from '@components/ButtonOutlined';
import React from 'react';
import ReactModal from 'react-modal';
import { BtnsWrapper, Content, Title } from './styles';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0, 0.3)',
    zIndex: 10000,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '80vw',
    padding: '22px 26px',
    borderRadius: '4px',
  },
};

interface CameraPermissionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CameraPermissionModal = ({
  isOpen,
  onClose,
}: CameraPermissionModalProps) => {
  const askForCameraPermission = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop());
        onClose();
      })
      .catch((err) => {
        // Permission denied or error occurred
        console.error('Camera permission denied or error:', err);
        onClose();
      });
  };

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={customStyles}
    >
      <Content>
        <Title>
          At the booth you can use the camera button to scan your experiences
        </Title>
        <BtnsWrapper>
          <ButtonOutlined title="Close" onClick={onClose} />
          <Button title="Allow" onClick={askForCameraPermission} />
        </BtnsWrapper>
      </Content>
    </ReactModal>
  );
};

export default CameraPermissionModal;
